module.exports = __webpack_public_path__ + "static/img/p_04.dfde2b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p_04.png
// module id = 607
// module chunks = 1